import React from 'react';
import BusinessIcon from '@mui/icons-material/Business';
import { styled } from '@mui/material';
import { ReactSVG } from 'react-svg';
import IconTree from './IconTree/IconTree';
import config from '../api/config';
// eslint-disable-next-line
import { NODES } from '../../entities/tree/config';

const VehicleIcon = styled(ReactSVG)`
  height: ${({ height }) => height || '20px'};
  width: ${({ width }) => width || '20px'};
  fill: ${({ color }) => `#${color}`};
  margin-right: 4px;

  svg {
    height: ${({ height }) => height || '18px'};
    width: ${({ width }) => width || '18px'};
    fill: ${({ color }) => `#${color}`};
  }

  .rc-tree-treenode-disabled & {
    opacity: 0.6;
  }
`;

const getIconVehicle = ({
  type = NODES.VEHICLE.TYPE,
  modelId,
  customIcon,
  color,
  token,
  width,
  height,
  isDealerCompanyView,
  sx,
}) => {
  const srcIcon = isDealerCompanyView && type === NODES.COMPANY.TYPE ? BusinessIcon : NODES[type].ICON;
  let icon = <IconTree icon={srcIcon} />;

  const currentToken = token || window.localStorage.getItem('token') || window.sessionStorage.getItem('token');

  if (type === NODES.VEHICLE.TYPE && modelId) {
    const params = new URLSearchParams({
      access_token: currentToken,
    }).toString();

    const commonIcon = `${config.baseUrl}/vehicle-models/${modelId}/icon`;
    icon = (
      <VehicleIcon
        sx={sx}
        width={width}
        height={height}
        color={color}
        src={`${customIcon || commonIcon}?${params}`}
        beforeInjection={(svg) => {
          svg.removeAttribute('fill');
          svg.querySelectorAll('[fill]').forEach((el) => el.removeAttribute('fill'));
          svg.querySelectorAll('[style]').forEach((el) => el.removeAttribute('style'));
        }}
      />
    );
  }

  return icon;
};

export default getIconVehicle;
